import React from 'react';
import { Grid, Button, Avatar } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    padding: '64px 15px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '36px 24px 40px',
    },
  },
  heroTitle: {
    fontSize: 48,
    fontWeight: 400,
    lineHeight: '36px',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 24,
    },
  },
  heroText: {
    fontSize: 16,
    maxWidth: 588,
    margin: '32px auto 0',
  },
  authorWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 20,
  },
  imgWrapper: {
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
  },
  authorImg: {
    width: 32,
    height: 32,
    border: `1px solid ${theme.palette.text.primary}`,
    '&:not(:first-child)': {
      marginLeft: '-10px',
    },
  },
  authorLabel: {
    fontStyle: 'italic',
  },
}));

function Hero() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h1 className={classes.heroTitle}>QuillBot’s Guide to Paraphrasing</h1>
      <div className={classes.heroText}>
        If you’re curious about what exactly it means to paraphrase, or how to paraphrase something,
        then this is the page for you.
      </div>
      <div className={classes.authorWrapper}>
        <div className={classes.imgWrapper}>
          <Avatar
            style={{ zIndex: 3 }}
            alt="Paige Pfeifer"
            src="https://quillbot.com/blog/content/images/2021/12/Paige-Pfeifer---Author-at-QuillBot-1.jpeg"
            className={classes.authorImg}
          />
          <Avatar
            style={{ zIndex: 2 }}
            alt="Sanhita Agarwal"
            src="https://quillbot.com/blog/content/images/2021/12/Sanhita-Agarwal---Head-of-SEO--QuillBot-.png"
            className={classes.authorImg}
          />
          <Avatar
            style={{ zIndex: 1 }}
            alt="Emily Perry"
            src="https://www.gravatar.com/avatar/f52289eb1ed788014d492df1f3e69736?s=250&d=mm&r=x"
            className={classes.authorImg}
          />
        </div>
        <div className={classes.authorLabel}>
          by&nbsp;
          <a
            href="https://quillbot.com/blog/author/paige/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Paige Pfeifer
          </a>
          ,&nbsp;
          <a
            href="https://quillbot.com/blog/author/sanhita/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Sanhita Agarwal
          </a>
          ,&nbsp;and&nbsp;
          <a
            href="https://quillbot.com/blog/author/emily/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Emily Perry
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
